import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideHighcharts } from 'highcharts-angular';

import { AppComponent } from './app/app.component';
import { provideVcTransloco } from './appInit/transloco.providers';
import { coreAppRoutes } from './app/core-app.routes';
import { environment } from './environments/environment';
import { ErrorInterceptor, AuthInterceptor, AuthGuard, ENV_CONFIG, SessionTimeoutInterceptor } from '@libs/vc-core-lib';
import { assessmentsErrorStatusInterceptor } from '@libs/vc-assessment-lib';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZonelessChangeDetection(),
        AuthGuard,
        provideRouter(coreAppRoutes),
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([assessmentsErrorStatusInterceptor])),
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SessionTimeoutInterceptor, multi: true },
        { provide: ENV_CONFIG, useValue: environment },
        ...provideVcTransloco(),
        provideHighcharts({
            instance: () => import('highcharts').then((m) => m.default ?? m),
        }),
    ],
}).catch((err) => console.error(err));
